// extracted by css-extract-rspack-plugin
export default {"queryEditor":"ehJGO","dragHandleContainer":"sr66V","dragHandle":"xcnA1","resizableBox":"SR5iB","open":"FvJwI","actionButtons":"mad0Y"};